import { Link } from "wouter";
import { ArrowLeft, Bot } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

export default function Agb() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-card to-background">
      <header className="sticky top-0 z-50 w-full border-b border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="container flex h-16 items-center justify-between px-4 sm:px-6 lg:px-8">
          <div className="flex items-center space-x-2">
            <Bot className="h-6 w-6 sm:h-8 sm:w-8 text-primary" />
            <span className="text-lg sm:text-xl font-bold text-primary font-playfair">Social Media A-Team</span>
          </div>
          <Link href="/">
            <Button variant="ghost" size="sm" data-testid="button-back-home">
              <ArrowLeft className="h-4 w-4 mr-2" />
              Zurück
            </Button>
          </Link>
        </div>
      </header>

      <main className="container px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <Card className="max-w-4xl mx-auto">
          <CardContent className="p-4 sm:p-6 lg:p-8 space-y-8">
            <div>
              <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold font-playfair text-primary" data-testid="text-agb-title">
                Allgemeine Geschäftsbedingungen (AGB)
              </h1>
              <p className="text-sm text-muted-foreground mt-2">Stand: Oktober 2026</p>
            </div>

            <section className="space-y-4">
              <h2 className="text-xl sm:text-2xl font-semibold text-foreground">§ 1 Geltungsbereich, Anbieter</h2>
              <div className="text-muted-foreground space-y-3">
                <p>
                  (1) Diese AGB gelten für alle Verträge über die Nutzung der Software-as-a-Service-Plattform
                  „The A-Team" (erreichbar unter app.socialmedia-a-team.com, nachfolgend „Plattform") zwischen der
                </p>
                <div className="pl-4">
                  <p className="font-medium text-foreground">SumoBrands UG (haftungsbeschränkt)</p>
                  <p>Plektrudisstr. 6, 50354 Hürth</p>
                  <p>
                    E-Mail:{" "}
                    <a href="mailto:Info@sumobrands.ai" className="text-primary hover:underline">
                      Info@sumobrands.ai
                    </a>
                  </p>
                  <p>(nachfolgend „Anbieter")</p>
                </div>
                <p>und ihren Kunden.</p>
                <p>
                  (2) Das Angebot richtet sich ausschließlich an Unternehmer im Sinne des § 14 BGB, juristische
                  Personen des öffentlichen Rechts oder öffentlich-rechtliche Sondervermögen. Ein Vertragsschluss
                  mit Verbrauchern ist ausgeschlossen. Mit der Registrierung bestätigt der Kunde, als Unternehmer
                  zu handeln.
                </p>
                <p>
                  (3) Entgegenstehende oder abweichende Geschäftsbedingungen des Kunden finden keine Anwendung,
                  auch wenn der Anbieter ihnen nicht ausdrücklich widerspricht.
                </p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl sm:text-2xl font-semibold text-foreground">§ 2 Vertragsgegenstand</h2>
              <div className="text-muted-foreground space-y-3">
                <p>
                  (1) Der Anbieter stellt dem Kunden eine cloudbasierte Plattform zur Erstellung, Planung und
                  Veröffentlichung von Social-Media-Inhalten zur Verfügung. Kernfunktionen sind insbesondere:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>
                    KI-gestützte Erstellung von Textbeiträgen und Bildern auf Basis der vom Kunden
                    bereitgestellten Unternehmensinformationen, Fotos und Vorgaben;
                  </li>
                  <li>Redaktions- und Freigabefunktionen (Prüfung, Bearbeitung, Freigabe durch den Kunden);</li>
                  <li>
                    Planung und Veröffentlichung freigegebener Inhalte auf den vom Kunden verbundenen
                    Social-Media-Konten (z. B. LinkedIn, Facebook, Instagram);
                  </li>
                  <li>ein KI-Chat-Assistent („Lina") zur Bedienungs- und Content-Unterstützung.</li>
                </ul>
                <p>
                  (2) Die Plattform erbringt eine technische Dienstleistung. Der Anbieter schuldet die
                  Bereitstellung der Funktionen, nicht jedoch einen bestimmten wirtschaftlichen Erfolg
                  (z. B. Reichweite, Follower-Zuwachs, Buchungen oder Umsätze).
                </p>
                <p>
                  (3) Der Funktionsumfang im Einzelnen ergibt sich aus der jeweils aktuellen
                  Leistungsbeschreibung auf der Website bzw. im Bestellprozess.
                </p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl sm:text-2xl font-semibold text-foreground">
                § 3 KI-generierte Inhalte, Transparenz und Kennzeichnung (EU-KI-Verordnung)
              </h2>
              <div className="text-muted-foreground space-y-3">
                <p>
                  (1) Die Inhaltserstellung erfolgt unter Einsatz generativer KI-Modelle von Drittanbietern
                  (derzeit insbesondere OpenAI, Anthropic und Google). Der Anbieter ist insoweit Anbieter eines
                  KI-Systems im Sinne der Verordnung (EU) 2024/1689 („KI-Verordnung"); der Kunde ist Betreiber
                  im Sinne dieser Verordnung, soweit er die erzeugten Inhalte verwendet oder veröffentlicht.
                </p>
                <p>
                  (2) Der KI-Chat-Assistent „Lina" ist ein KI-System. Der Kunde interagiert dort nicht mit einem
                  Menschen; hierauf wird in der Benutzeroberfläche hingewiesen (Art. 50 Abs. 1 KI-Verordnung).
                </p>
                <p>
                  (3) Der Anbieter kennzeichnet KI-generierte Inhalte in maschinenlesbarer Form, soweit dies nach
                  dem Stand der Technik möglich und die Kennzeichnung nach Art. 50 Abs. 2 KI-Verordnung
                  vorgeschrieben ist (z. B. Metadaten-Kennzeichnung bei KI-generierten Bildern). Der Kunde ist
                  nicht berechtigt, solche Kennzeichnungen gezielt zu entfernen.
                </p>
                <p>
                  (4) Der Kunde bleibt für die Veröffentlichung der Inhalte verantwortlich. Ihn können als
                  Betreiber eigene Transparenzpflichten treffen, insbesondere die Offenlegungspflicht nach
                  Art. 50 Abs. 4 KI-Verordnung, wenn Bildmaterial durch KI so bearbeitet wird, dass es echten
                  Personen, Orten oder Ereignissen täuschend ähnlich erscheint („Deepfake"). Der Anbieter stellt
                  hierfür Hinweise und, soweit verfügbar, technische Unterstützung bereit; die rechtliche
                  Verantwortung für die Kennzeichnung veröffentlichter Inhalte liegt beim Kunden.
                </p>
                <p>
                  (5) KI-generierte Inhalte können sachliche Fehler enthalten. Der Kunde ist verpflichtet, jeden
                  Inhalt vor Freigabe auf Richtigkeit, Rechtmäßigkeit und Markenkonformität zu prüfen. Eine
                  Veröffentlichung erfolgt grundsätzlich erst nach Freigabe durch den Kunden.
                </p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl sm:text-2xl font-semibold text-foreground">
                § 4 Vertragsschluss, Laufzeit und Kündigung
              </h2>
              <div className="text-muted-foreground space-y-3">
                <p>(1) Der Vertrag kommt mit Abschluss des Registrierungs- und Bestellprozesses zustande.</p>
                <p>
                  (2) Der Vertrag beginnt mit Abschluss der Bestellung. Eine kostenlose Testphase wird nicht
                  gewährt. Die monatliche Gebühr wird jeweils zu Beginn des Abrechnungsmonats fällig.
                </p>
                <p>
                  (3) Das Abonnement verlängert sich automatisch um jeweils einen Monat und kann jederzeit zum
                  Ende des laufenden Abrechnungsmonats gekündigt werden.
                </p>
                <p>
                  (4) Der Kunde kann das Abonnement jederzeit mit Wirkung zum Ende des laufenden
                  Abrechnungszeitraums über das Kundenportal kündigen. Der Anbieter kann mit einer Frist von
                  einem Monat zum Ende eines Abrechnungszeitraums kündigen. Das Recht zur außerordentlichen
                  Kündigung aus wichtigem Grund bleibt unberührt.
                </p>
                <p>
                  (5) Nach Vertragsende werden Kundendaten und erstellte Inhalte nach Maßgabe der
                  Datenschutzerklärung gelöscht. Der Kunde ist verantwortlich, benötigte Inhalte vor
                  Vertragsende zu exportieren.
                </p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl sm:text-2xl font-semibold text-foreground">§ 5 Preise und Zahlung</h2>
              <div className="text-muted-foreground space-y-3">
                <p>
                  (1) Es gelten die im Bestellprozess ausgewiesenen Preise. Sofern nicht anders ausgewiesen,
                  verstehen sich Preise zuzüglich gesetzlicher Umsatzsteuer.
                </p>
                <p>
                  (2) Die Zahlungsabwicklung erfolgt über den Zahlungsdienstleister Stripe. Das Entgelt wird
                  monatlich im Voraus fällig und automatisch eingezogen. Rechnungen werden elektronisch
                  bereitgestellt.
                </p>
                <p>
                  (3) Bei Zahlungsverzug ist der Anbieter berechtigt, den Zugang zur Plattform nach erfolgloser
                  Mahnung zu sperren, bis die offenen Beträge beglichen sind.
                </p>
                <p>
                  (4) Preisänderungen werden mindestens sechs Wochen vor Wirksamwerden in Textform angekündigt
                  und gelten nur für künftige Abrechnungszeiträume. Der Kunde kann bis zum Wirksamwerden
                  ordentlich kündigen.
                </p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl sm:text-2xl font-semibold text-foreground">
                § 6 Pflichten und Verantwortung des Kunden
              </h2>
              <div className="text-muted-foreground space-y-3">
                <p>
                  (1) Der Kunde hält seine Zugangsdaten geheim und informiert den Anbieter unverzüglich bei
                  Verdacht auf Missbrauch.
                </p>
                <p>
                  (2) Der Kunde stellt sicher, dass er an sämtlichen von ihm hochgeladenen Inhalten
                  (insbesondere Fotos, Logos, Texte) die erforderlichen Rechte hält, einschließlich etwaiger
                  Einwilligungen abgebildeter Personen.
                </p>
                <p>
                  (3) Der Kunde verbindet seine Social-Media-Konten in eigener Verantwortung und hält die
                  Nutzungsbedingungen der jeweiligen Plattformen (z. B. LinkedIn, Meta) ein.
                </p>
                <p>
                  (4) Der Kunde prüft und genehmigt Inhalte vor Veröffentlichung (§ 3 Abs. 5) und erfüllt die
                  ihn als Betreiber treffenden Kennzeichnungspflichten (§ 3 Abs. 4).
                </p>
                <p>
                  (5) Der Kunde nutzt die Plattform nicht zur Erstellung oder Verbreitung rechtswidriger,
                  irreführender, diskriminierender oder gegen Rechte Dritter verstoßender Inhalte.
                </p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl sm:text-2xl font-semibold text-foreground">§ 7 Nutzungsrechte</h2>
              <div className="text-muted-foreground space-y-3">
                <p>
                  (1) Der Kunde erhält an den für ihn erzeugten Inhalten ein einfaches, zeitlich und räumlich
                  unbeschränktes Recht zur Nutzung für eigene geschäftliche Zwecke, einschließlich der
                  Veröffentlichung auf Social-Media-Plattformen und eigenen Kanälen.
                </p>
                <p>
                  (2) Der Kunde wird darauf hingewiesen, dass rein KI-generierte Inhalte nach derzeitiger
                  Rechtslage urheberrechtlich nicht oder nur eingeschränkt schutzfähig sein können und dass
                  Drittanbieter-Modelle vergleichbare Inhalte auch für andere Nutzer erzeugen können. Ein
                  Ausschließlichkeitsrecht wird insoweit nicht eingeräumt.
                </p>
                <p>
                  (3) An der Plattform selbst erhält der Kunde für die Vertragslaufzeit ein einfaches, nicht
                  übertragbares Nutzungsrecht.
                </p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl sm:text-2xl font-semibold text-foreground">
                § 8 Drittplattformen und Drittanbieter
              </h2>
              <div className="text-muted-foreground space-y-3">
                <p>
                  (1) Die Veröffentlichung auf Social-Media-Plattformen erfolgt über technische Schnittstellen
                  von Drittanbietern. Verfügbarkeit, Funktionsumfang und Regeln der Ziel-Plattformen liegen
                  außerhalb des Einflussbereichs des Anbieters.
                </p>
                <p>
                  (2) Der Anbieter haftet nicht für Änderungen, Einschränkungen oder Sperrungen durch
                  Social-Media-Plattformen oder deren Schnittstellen, es sei denn, der Anbieter hat diese zu
                  vertreten.
                </p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl sm:text-2xl font-semibold text-foreground">§ 9 Verfügbarkeit und Wartung</h2>
              <div className="text-muted-foreground space-y-3">
                <p>
                  (1) Der Anbieter erbringt die Leistungen mit branchenüblicher Sorgfalt und Verfügbarkeit.
                  Wartungsarbeiten werden, soweit planbar, außerhalb üblicher Geschäftszeiten durchgeführt.
                </p>
                <p>
                  (2) Ein bestimmtes Service-Level (SLA) wird nicht geschuldet, soweit nicht ausdrücklich
                  vereinbart.
                </p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl sm:text-2xl font-semibold text-foreground">§ 10 Haftung</h2>
              <div className="text-muted-foreground space-y-3">
                <p>
                  (1) Der Anbieter haftet unbeschränkt für Vorsatz und grobe Fahrlässigkeit sowie für Schäden
                  aus der Verletzung von Leben, Körper oder Gesundheit und nach dem Produkthaftungsgesetz.
                </p>
                <p>
                  (2) Bei einfacher Fahrlässigkeit haftet der Anbieter nur für die Verletzung wesentlicher
                  Vertragspflichten (Kardinalpflichten), der Höhe nach begrenzt auf den vertragstypischen,
                  vorhersehbaren Schaden, maximal jedoch auf die vom Kunden in den letzten zwölf Monaten vor
                  dem Schadensereignis gezahlten Entgelte.
                </p>
                <p>
                  (3) Der Anbieter haftet nicht für Schäden aus der Veröffentlichung von Inhalten, die der
                  Kunde ohne die nach § 3 Abs. 5 geschuldete Prüfung freigegeben hat, sowie für die Verletzung
                  von Kennzeichnungspflichten, die den Kunden als Betreiber treffen.
                </p>
                <p>
                  (4) Die Verjährungsfrist für Ansprüche des Kunden beträgt zwölf Monate, ausgenommen Ansprüche
                  nach Abs. 1.
                </p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl sm:text-2xl font-semibold text-foreground">
                § 11 Datenschutz und Auftragsverarbeitung
              </h2>
              <div className="text-muted-foreground space-y-3">
                <p>
                  (1) Informationen zur Verarbeitung personenbezogener Daten enthält die{" "}
                  <Link href="/datenschutz" className="text-primary hover:underline">
                    Datenschutzerklärung
                  </Link>
                  .
                </p>
                <p>
                  (2) Soweit der Anbieter personenbezogene Daten im Auftrag des Kunden verarbeitet (z. B.
                  Personenfotos des Kunden), schließen die Parteien auf Anfrage einen
                  Auftragsverarbeitungsvertrag nach Art. 28 DSGVO.
                </p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl sm:text-2xl font-semibold text-foreground">§ 12 Änderungen dieser AGB</h2>
              <div className="text-muted-foreground space-y-3">
                <p>
                  (1) Der Anbieter kann diese AGB mit Wirkung für die Zukunft ändern, soweit dies aufgrund
                  geänderter rechtlicher oder technischer Rahmenbedingungen erforderlich ist und den Kunden
                  nicht unangemessen benachteiligt.
                </p>
                <p>
                  (2) Änderungen werden mindestens sechs Wochen vor Wirksamwerden in Textform angekündigt.
                  Widerspricht der Kunde nicht bis zum Wirksamwerden, gelten die Änderungen als angenommen; auf
                  diese Folge wird in der Ankündigung hingewiesen. Bei Widerspruch kann jede Partei zum
                  Wirksamwerden der Änderung kündigen.
                </p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl sm:text-2xl font-semibold text-foreground">§ 13 Schlussbestimmungen</h2>
              <div className="text-muted-foreground space-y-3">
                <p>(1) Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.</p>
                <p>
                  (2) Ausschließlicher Gerichtsstand für alle Streitigkeiten aus oder im Zusammenhang mit
                  diesem Vertrag ist Köln, soweit der Kunde Kaufmann, juristische Person des öffentlichen
                  Rechts oder öffentlich-rechtliches Sondervermögen ist.
                </p>
                <p>
                  (3) Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit der übrigen
                  Bestimmungen unberührt.
                </p>
              </div>
            </section>
          </CardContent>
        </Card>
      </main>

      <footer className="border-t border-border/40 py-6 sm:py-8 mt-8">
        <div className="container px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <div className="flex items-center space-x-2">
              <Bot className="h-5 w-5 sm:h-6 sm:w-6 text-primary" />
              <span className="font-semibold text-primary font-playfair text-sm sm:text-base">Social Media A-Team</span>
            </div>
            <div className="flex flex-wrap justify-center gap-4 text-xs sm:text-sm text-muted-foreground">
              <span>© 2026 SumoBrands</span>
              <Link href="/impressum" className="hover:text-primary hover:underline" data-testid="link-footer-impressum">
                Impressum
              </Link>
              <Link href="/datenschutz" className="hover:text-primary hover:underline" data-testid="link-footer-datenschutz">
                Datenschutz
              </Link>
              <Link href="/agb" className="hover:text-primary hover:underline" data-testid="link-footer-agb">
                AGB
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
